export const wrapperStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  aspectRatio: 1,

  '& > span': {
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
  },

  '& > span:nth-of-type(1)': {
    top: '-1px',
  },

  '& > span:nth-of-type(2)': {
    bottom: '-1px',
  },
};

export const getIconStyles = isActive => ({
  display: 'flex',

  ...(isActive && {
    color: ({ palette }) => palette.primary.main,
  }),
});
